import React, { useState } from 'react'
import Classes from '../MainLayout.module.css'
import ProfileDropDown from '../ProfileDropDown'
import { useLocation, useNavigate } from 'react-router-dom';
import convertToRgba from '../../../../utils/colorUtils';
import { useEffect } from 'react';
import Notifications from '../../../GlobalComponents/Notification/Notifcation';
import { Switch, FormControlLabel } from "@mui/material";
import { useSelector } from 'react-redux';

const MenuIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height='20px' viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" /></svg>
)

export default function Header({ setopenMobileSidebar, isMobile }) {
    const location = useLocation();
    const navigateTo = useNavigate();
    const [activePage, setActivePage] = useState(location.pathname);
    const { user } = useSelector((state) => state.auth);
    let userName = user?.menteeProfile?.basicInfo?.name;

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    function formatPageTitle(pathname) {
        if (!pathname || pathname === '/') return 'Dashboard';
        const first = pathname.split('?')[0].split('#')[0].split('/').filter(Boolean)[0] || '';
        return first;
    }

    return (
        <>
            <header className={Classes.navbar}  >
                {isMobile ?
                    <div onClick={() => { setopenMobileSidebar(true) }} className='flexAlign10' >
                        <div className='flex' > <MenuIcon /> </div>
                        <h4 className={Classes.headTitle} > {formatPageTitle(location?.pathname)} </h4>
                    </div>
                    :
                    <>
                        {activePage === '/' ?
                            <div>{userName && <h5>Hello, {userName}!</h5>} </div>
                            : <div></div>
                        }
                    </>
                }

                <div className={Classes.headerRight} >
                    {/* <div className={Classes.tooltipCon} onClick={() => { navigateTo('/contact-us') }} >
                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                    </div> */}
                    <Notifications />
                    <div className={Classes.verticleLine} ></div>
                    <div className={Classes.profileSection}>
                        <ProfileDropDown />
                    </div>
                </div>
            </header>
        </>
    )
}
